import { ConcreteEncodable } from "./ConcreteEncodable";

import { SysTradeDateRolloverEventImplEncoder } from "../../encoder/SysTradeDateRolloverEventImplEncoder";

import * as CubiqTS from "../../index";
import { SysTradeDateRolloverEvent } from "../SysTradeDateRolloverEvent";

export class SysTradeDateRolloverEventImpl
  extends ConcreteEncodable
  implements SysTradeDateRolloverEvent
{
  public static enType: string = "com.bcdfx.model.event.SysTradeDateRolloverEventImpl";

  /*FID=1*/
  public rolledSystemTradeDate: CubiqTS.moment.Moment | null = null;
  /*FID=2*/
  public nextSystemTradeDateRoll: CubiqTS.moment.Moment | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SysTradeDateRolloverEventImplEncoder.Instance;
    this.setEncodableType(SysTradeDateRolloverEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SysTradeDateRolloverEventImpl[" +
      "rolledSystemTradeDate=" +
      this.rolledSystemTradeDate +
      "nextSystemTradeDateRoll=" +
      this.nextSystemTradeDateRoll +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
